/* eslint-disable no-template-curly-in-string */
declare global {
  interface Window {
    ENV: any;
  }
}

export const TENANT =
  window.ENV.TENANT === '${VEENGU_BP_TENANT}' ? process.env.REACT_APP_TENANT : window.ENV.TENANT;
export const API_SOLUTION =
  window.ENV.SOLUTION === '${VEENGU_BP_SOLUTION}'
    ? process.env.REACT_APP_API_SOLUTION
    : window.ENV.SOLUTION;
// export const solutionId = API_SOLUTION;

const SOLUTION_LIST_RAW =
  window.ENV.SOLUTION_LIST === '${VEENGU_BP_SOLUTION_LIST}'
    ? process.env.REACT_APP_SOLUTION_LIST
    : window.ENV.SOLUTION_LIST;

export const SOLUTION_LIST: string[] = SOLUTION_LIST_RAW
  ? SOLUTION_LIST_RAW.split(',')
  : [API_SOLUTION];

const API_HOST = process.env.REACT_APP_API_HOST;
const ENV_API_URL = API_HOST
  ? `${API_HOST.startsWith('127.0.0.1') ? `http` : `https`}://${API_HOST}`
  : '';
const DOCKER_API_URL = window.ENV.API_URL === '${VEENGU_BP_API_URL}' ? '' : window.ENV.API_URL;
export const API_URL = ENV_API_URL || DOCKER_API_URL;

export const GOOGLE_MAP_API_KEY =
  window.ENV.GOOGLE_MAP_API_KEY === '${VEENGU_BP_GOOGLE_MAP_API_KEY}'
    ? process.env.REACT_APP_GOOGLE_MAP_API_KEY
    : window.ENV.GOOGLE_MAP_API_KEY;

export const GOOGLE_RECAPTCHA_SITE_KEY =
  window.ENV.GOOGLE_RECAPTCHA_SITE_KEY === '${VEENGU_BP_GOOGLE_RECAPTCHA_SITE_KEY}'
    ? process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
    : window.ENV.GOOGLE_RECAPTCHA_SITE_KEY;
